<template>
  <div :key="`${account._id}_${accountKey}`" class="m-0" @click="open">
    <!--<div
      v-if="isEditRoute && isClan"
      class="d-flex justify-content-between my-5 px-5 align-items-center"
    >
      <Subheader
        class="secondary-font"
        :text="$t('_web_clans_edit-clan', 'Edit clan')"
      />
      <StatusBarEditActions no-cancel class="status-bar-actions" />
    </div>-->
    <div class="row">
      <div class="col-12" :class="{ 'col-md-9': isProfileEntity }">
        <router-view name="cover" />
        <div
          v-if="isProfileRemoved"
          class="mt-3 text-right font-size-sm"
          :style="{ color: $scss.colors.redBg }"
        >
          {{ $t('_web_profile-removed', 'Removed profile') }}
        </div>
        <StatusBar v-else class="mb-5" />
      </div>
      <div
        v-if="isProfileEntity"
        class="col-12 col-md-3"
        :class="
          $route.path.includes('edit') || $route.name === 'contacts'
            ? 'responsive-view'
            : 'col-12 col-md-3'
        "
      >
        <SidebarCounters v-show="!isProfileRemoved" />
      </div>
    </div>
    <div class="row">
      <div
        class="col-12"
        :class="{
          'col-md-9 order-1 order-md-0 profile-newsfeed': isProfileEntity,
        }"
      >
        <HeraDummyList
          v-if="isProfileRemoved"
          icon-name="dummy/newsfeed"
          position="center"
          size="200"
          :header-text="$t('_web_empty-wall', 'This feed is empty')"
        />
        <ContentLayout v-else class="px-0 mx-0">
          <div class="py-0 flex-grow-0">
            <!-- commented out from user profile -->
            <!-- <Comments          
              v-if="this.$route.params.accountId"         
              :post="{ id: this.$route.params.accountId }"
            /> -->
            <NavMenu v-if="!navbarIsHidden" />
            <router-view name="main" />
            <StatusBarEditActions
              v-if="isEditRoute"
              class="mt-5  status-bar-actions smallerscr"
            />
          </div>
        </ContentLayout>
      </div>
      <div
        v-if="isProfileEntity"
        class="col-12 col-md-3 order-0 order-order-1"
        :class="
          $route.path.includes('edit') || $route.name === 'contacts'
            ? 'responsive-view'
            : 'col-12 col-md-3'
        "
      >
        <SidebarInfo v-show="!isProfileRemoved" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
//import Subheader from '@/components/atoms/Subheader';
import ContentLayout from '@/views/ContentCard';
import StatusBar from '@/views/account/header/statusBar';
import SidebarCounters from '@/views/account/sidebarCounters';
import SidebarInfo from '@/views/account/sidebarInfo';
import NavMenu from '@/views/account/NavMenu';
import StatusBarEditActions from './header/statusBar/edit/actions';
import HeraDummyList from '@/components/common/HeraDummyList';
// import Comments from '@/components/comments/Comments';
import { redirectDeletedAccount } from '@/router/account/redirect';
import { VANITY_PREFIX } from '@/constants/router';
import * as ACCOUNT from '@/constants/accounts';
import viewsTrackingMixin from '@/mixins/metrics';

export default {
  name: 'Account',
  components: {
    ContentLayout,
    StatusBar,
    HeraDummyList,
    NavMenu,
    StatusBarEditActions,
    SidebarCounters,
    SidebarInfo,
    //Subheader,
    // Comments,
  },
  mixins: [viewsTrackingMixin],
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myId: 'accountId' }),
    ...mapGetters(['accountKey']),
    isProfileEntity() {
      return [ACCOUNT.PROFILE, ACCOUNT.ORGANIZATION, ACCOUNT.CLAN].includes(
        this.account._type
      );
    },
    isProfileRemoved() {
      return this.$lodash.get(this, 'account.deleted');
    },
    isTournamentEntity() {
      return [ACCOUNT.TOURNAMENT].includes(this.account._type);
    },
    isEditRoute() {
      return (
        this.$route.name === this.$routerNames.EDIT ||
        this.$route.name === `${VANITY_PREFIX}${this.$routerNames.EDIT}`
      );
    },
    isClan() {
      return ACCOUNT.CLAN === this.account._type;
    },
    // accountId() {
    //   // not use state
    //   return this.$lodash.get(this, '$route.params.accountId', '');
    // },
    navbarIsHidden() {
      return (
        this.isProfileEntity ||
        this.$lodash.get(this, '$route.meta.navbarIsHidden', false)
      );
    },
    tournamentID() {
      return this.$route.params.accountId;
    },
  },
  created() {},
  mounted() {
    // this.trackViewAction(this.accountId, this.account._type);
  },
  destroyed() {
    const hasAccount = !this.$lodash.isEmpty(
      this.$store.state.accounts.current.account
    );
    if (hasAccount) {
      const emptyAccount = !this.$store.state.accounts.current.account._id;
      if (
        !emptyAccount &&
        this.$route.name !== 'createClanDetails' &&
        this.accountId === this.$store.state.accounts.current.account._id
      ) {
        this.removeAccountModel();
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isTournamentEntity) {
      this.clearCurrentTournament();
      this.clearAllStages();
      this.clearAllBlocks();
    }
    next();
  },
  methods: {
    ...mapActions([
      'fetchAccount',
      'openModal',
      'closeModal',
      'getEntityDetailsByVanityUrl',
    ]),
    ...mapMutations('current', ['removeAccountModel']),
    ...mapMutations([
      'clearCurrentTournament',
      'clearAllStages',
      'clearAllBlocks',
    ]),
    open() {},
  },
  async beforeRouteUpdate(to, from, next) {
    const { params } = to;
    let account;
    if (
      to.params.accountId !== from.params.accountId ||
      to.params.vanityId !== from.params.vanityId
    ) {
      if (to.params.vanityId) {
        const updatedParams =
          to.params.accountId && to.params.accountType
            ? {
                entityId: to.params.accountId,
                entityType: to.params.accountType,
              }
            : await this.getEntityDetailsByVanityUrl(to.params.vanityId);
        account = await this.fetchAccount({
          accountType: updatedParams.entityType,
          accountId: updatedParams.entityId,
        });
      } else {
        account = await this.fetchAccount(params);
      }
    } else {
      account = this.account;
    }
    redirectDeletedAccount(account, to, next);
  },
};
</script>
<style lang="scss">
@media (max-width: 767px) {
  .responsive-view {
    display: none;
  }
  .profile-newsfeed {
    padding: 0px !important;
  }
  .smallerscr {
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    button {
      min-width: 8rem !important;
    }
  }
}
</style>
